import { Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  onClose: () => void;
};

const PdfGenerationModal: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant='body1' sx={{ fontSize: '20px', fontWeight: 500 }}>
            {t('result_doctor.details.modal.pdfGeneration.message')}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button 
              variant='link' 
              color='primary' 
              onClick={onClose}
              sx={{ color: (theme) => theme.palette.primary.main }}
            >
              {t('common.words.ok')}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PdfGenerationModal;
